'use client'

import { useEffect } from "react";

/**
 * If browser back button was used, flush cache
 * This ensures that Safari doesn't break the page when navigating back
 */
export default function useSafariCacheFix() {
  useEffect(() => {
    const handleBFCache = (event: PageTransitionEvent) => {
      if (event.persisted) {
        console.debug('Flushing bf-cache');
        window.location.reload();
      }
    }

    window.addEventListener('pageshow', handleBFCache)
    return () => {
      window.removeEventListener('pageshow', handleBFCache)
    }
  }, []);

  return null;
}
